import { render, staticRenderFns } from "./sysconfigdetail.vue?vue&type=template&id=00fe535e&scoped=true"
import script from "./sysconfigdetail.vue?vue&type=script&lang=js"
export * from "./sysconfigdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fe535e",
  null
  
)

export default component.exports